import ScribbleBackground from 'components/ScribbleBackground'
import { QRCodeSVG } from 'qrcode.react'

import UnauthenticatedLayout, { UNAUTHENTICATED_BACKGROUND_KEYS } from 'components/UnauthenticatedLayout'

import { STRING } from 'resources'
import { APP_LINK } from 'resources/urls'

import {
  ScreenContainer,
  ContentContainer,
  WelcomeTitle,
  WelcomeMessageContainer,
  WelcomeMessageText,
  WelcomeMessageRedText,
  QRCodeContainer,
  QRCodeLink,
} from './styles'

const LandingPage = () => (
  <ScreenContainer>
    <UnauthenticatedLayout backgroundKey={UNAUTHENTICATED_BACKGROUND_KEYS.spaghettiOverlayWithLogo}>
      <ScribbleBackground>
        <ContentContainer>
          <WelcomeTitle>{STRING.deprecationNotice.header}</WelcomeTitle>
          <WelcomeMessageContainer>
            <WelcomeMessageText>{STRING.deprecationNotice.title.part1}</WelcomeMessageText>
            <WelcomeMessageRedText>{STRING.deprecationNotice.title.part2}</WelcomeMessageRedText>
          </WelcomeMessageContainer>
          <QRCodeContainer>
            <QRCodeSVG value={APP_LINK} size={258} />
            <QRCodeLink to={APP_LINK} target="_blank">
              {APP_LINK}
            </QRCodeLink>
          </QRCodeContainer>
        </ContentContainer>
      </ScribbleBackground>
    </UnauthenticatedLayout>
  </ScreenContainer>
)

export default LandingPage
